import React, { useEffect, useState } from 'react';
import { MediaInfo } from './types.js';
import { MediaFallback } from './MediaFallback.js';

interface VideoMediaProps {
    media: MediaInfo;
    status?: string;
}

export const VideoMedia: React.FC<VideoMediaProps> = ({ media, status }) => {
    const [hasError, setHasError] = useState(() => !media.url);

    useEffect(() => {
        setHasError(!media.url);
    }, [media.url]);

    if (hasError) {
        // Nunca defaultar failed: evita flash “indisponível” com status ainda vazio.
        return <MediaFallback type="video" status={status} />;
    }

    return (
        <div className="max-w-xs">
            <video
                controls
                className="w-full h-auto max-h-80 rounded-lg bg-gray-900"
                onError={() => setHasError(true)}
            >
                <source src={media.url} type={media.mimetype || 'video/mp4'} />
                Seu navegador não suporta vídeos.
            </video>
        </div>
    );
};
